module.exports = __webpack_public_path__ + "img/icon_home_hezuo_four@3x.2584c637.png";